<template>
    <div class="bottom-menu-bar">
        <div class="bottom-menu-item-half" v-bind:class="{'bottom-menu-item-half-active' : selectedGroupDataList.length > 0}" @click="moveGroupItem">
            <p><i class="bm-icon iconfont icon-yidong"></i></p>
            <p class="bm-text">移动</p>
        </div>
        <div class="bottom-menu-item-half" v-bind:class="{'bottom-menu-item-half-active' : selectedGroupDataList.length > 0}" @click="deleteGroupItem">
            <p><i class="bm-icon iconfont icon-shanchu"></i></p>
            <p class="bm-text">删除</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GroupBottomBar',
    computed: {
        recordOriginalData() {
            return this.$store.state.record.recordOriginalData;
        },
        selectedGroupDataList(){
            return this.$store.state.group.selectedGroupDataList;
        },
    },
    methods:{
        moveGroupItem() {
            if(this.selectedGroupDataList.length > 0){
                this.$store.dispatch('group/toggleChangeGroup', true);
            }
        },
        deleteGroupItem() {
            var me = this, msg = '';
            // 获取删除文案
            _.forEach(this.selectedGroupDataList, arr => {
                var recordData = me.recordOriginalData[arr[0]];
                if(recordData.pipan || recordData.nunpan || recordData.reminder || recordData.ai) {
                    msg = msg.indexOf('待删除八字中有') == -1 ? msg+'待删除八字中有' : msg;
                    msg = recordData.pipan && msg.indexOf('批盘') == -1 ? msg+'批盘、' : msg;
                    msg = recordData.nunpan && msg.indexOf('论盘') == -1 ? msg+'论盘、' : msg;
                    msg = recordData.reminder && msg.indexOf('生日提醒') == -1 ? msg+'生日提醒、' : msg;
                    msg = recordData.ai && msg.indexOf('测算结果') == -1 ? msg+'测算结果、' : msg;
                }
            })
            msg = msg.charAt(msg.length-1)=='、' ? msg.slice(0, -1) : msg;
            msg = msg != '' ? msg+'数据，\n删除不可恢复' : msg;
            this.$bus.emit('showDeleteRecordItemPop', {
                text1: '确定要删除选中的八字记录吗？',
                text2: msg,
                cb: function() {
                    me.$store.dispatch('group/deleteGroupListData');
                }
            })
        }
    }
}
</script>